import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HasCloseEvent } from '../../../interfaces/has-close-event.interface';
import { InformationModel } from '../../../models/information.model';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-information',
  standalone: true,
  imports: [
    TranslocoDirective
  ],
  templateUrl: './information.component.html',
  styleUrl: './information.component.scss'
})
export class InformationComponent implements HasCloseEvent {
  @Input() public data: InformationModel = new InformationModel();
  @Output() public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected buttonClick(): void {
    this.closeEvent.emit(true);
  }
}
